export const MODALITY = ['In-Person', 'Virtual', 'Hybrid'];
